import script from "./liveClassify.vue?vue&type=script&setup=true&lang=ts"
export * from "./liveClassify.vue?vue&type=script&setup=true&lang=ts"

import "./liveClassify.vue?vue&type=style&index=0&id=8a88730a&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a88730a"]])

export default __exports__